export const WIDGET_INFO = 'WIDGET_INFO';
export const WIDGET_INFO_SUCCESS = 'WIDGET_INFO_SUCCESS';
export const WIDGET_LOAD = 'WIDGET_LOAD';
export const SOCIAL_PROOF = 'SOCIAL_PROOF';
export const SOCIAL_PROOF_SUCCESS = 'SOCIAL_PROOF_SUCCESS';

export const SET_UNI_GROUP = 'SET_UNI_GROUP';

export const SET_TITLES = 'SET_TITLES';
export const CHAT_HEADER_SET = 'CHAT_HEADER_SET';
export const CHECK_IF_MOBILE = 'CHECK_IF_MOBILE';
export const SET_UTM_DATA = 'SET_UTM_DATA';

export const SINGLE_UNIVERSITY_WIDGET_INFO = 'SINGLE_UNIVERSITY_WIDGET_INFO';

export const setUniGroup = (universityIds = []) => ({
    type: SET_UNI_GROUP,
    payload: {
        universityIds,
    },
});

export const setTitles = (titles = {}) => ({
    type: SET_TITLES,
    payload: titles,
});
